<script setup>
import { ref } from "vue";
import { fetchTopics, addTopic } from "./api";

const topics = ref([]);
const loading = ref(false);
const error = ref("");
const newTopic = ref("");
const adding = ref(false);
const addError = ref("");

async function load() {
  loading.value = true; error.value = "";
  try { topics.value = await fetchTopics(); }
  catch { error.value = "Couldn't load topics."; }
  finally { loading.value = false; }
}

async function add() {
  if (!newTopic.value.trim()) return;
  adding.value = true; addError.value = "";
  try { await addTopic(newTopic.value.trim()); newTopic.value = ""; await load(); }
  catch { addError.value = "Couldn't add topic."; }
  finally { adding.value = false; }
}

load();
</script>

<template>
  <section>
    <h1 class="text-h5 mb-4">Notification Topics</h1>
    <VCard class="pa-4" max-width="600">
      <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>
      <div class="d-flex gap-2 mb-4">
        <VTextField v-model="newTopic" label="New Topic" hide-details @keydown.enter.prevent="add" />
        <VBtn :loading="adding" @click="add">Add</VBtn>
      </div>
      <VAlert v-if="addError" type="warning" class="mb-4">{{ addError }}</VAlert>
      <VProgressLinear v-if="loading" indeterminate class="mb-2" />
      <VList v-if="topics.length">
        <VListItem v-for="t in topics" :key="t._id" :title="t.topic" />
      </VList>
      <p v-else-if="!loading" class="text-medium-emphasis">No topics yet.</p>
    </VCard>
  </section>
</template>
